var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-title',[_vm._v(_vm._s(_vm.$t('deliveries.list_page_title')))]),_c('deliveries-table',{ref:"table",on:{"company-filter":function($event){_vm.companyFilter = $event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }